import { render, staticRenderFns } from "./Prestation.vue?vue&type=template&id=3a1fd93a"
import script from "./Prestation.vue?vue&type=script&lang=js"
export * from "./Prestation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports